angular.module('unica.basic_services')

.factory('getBaseApiURL', function(CONFIG) {
	return CONFIG.baseURL;
})

.factory('getBaseWebURL', function(CONFIG) {
	return CONFIG.webURL;
})


.factory('transformRequestAsFormPost', function() {

	// I prepare the request data for the form post.
	function transformRequest( data, getHeaders ) {
		var headers = getHeaders();
		headers[ "Content-type" ] = "application/x-www-form-urlencoded; charset=utf-8";
		return( serializeData( data ) );
	}

	// Return the factory value.
	return( transformRequest );

	function serializeData(data) {
		// If this is not an object, defer to native stringification.
		if ( ! angular.isObject( data ) ) {
			return( ( data == null ) ? "" : data.toString() );
		}
		var buffer = [];

		// Serialize each key in the object.
		for (var name in data) {
			if ( ! data.hasOwnProperty( name ) ) {
				continue;
			}
			var value = data[ name ];
			buffer.push(
				encodeURIComponent( name ) + "=" + encodeURIComponent( ( value == null ) ? "" : value )
			);
		}

		// Serialize the buffer and clean it up for transportation.
		var source = buffer .join( "&" ) .replace( /%20/g, "+" );
		return( source );

	}

})

.factory('preventTemplateCache', function($injector) {
	return {
		'request': function(config) {
			if (config.url.indexOf('templates') !== -1) {
				config.url = config.url + '?t=' + ( new Date().getTime() );
			}
			return config;
		}
	}
})

.factory('getCountries', function() {

	return [

		{
			name: "Italia",
			dial_code: "+39",
			code: "IT"
		},

		{
			name: "Afghanistan",
			dial_code: "+93",
			code: "AF"
		}, {
			name: "Albania",
			dial_code: "+355",
			code: "AL"
		}, {
			name: "Algeria",
			dial_code: "+213",
			code: "DZ"
		}, {
			name: "Andorra",
			dial_code: "+376",
			code: "AD"
		}, {
			name: "Angola",
			dial_code: "+244",
			code: "AO"
		}, {
			name: "Antigua e Barbuda",
			dial_code: "+1268",
			code: "AG"
		}, {
			name: "Arabia Saudita",
			dial_code: "+966",
			code: "SA"
		}, {
			name: "Argentina",
			dial_code: "+54",
			code: "AR"
		}, {
			name: "Armenia",
			dial_code: "+374",
			code: "AM"
		}, {
			name: "Australia",
			dial_code: "+61",
			code: "AU"
		}, {
			name: "Austria",
			dial_code: "+43",
			code: "AT"
		}, {
			name: "Azerbaijan",
			dial_code: "+994",
			code: "AZ"
		},


		{
			name: "Bahamas",
			dial_code: "+1 242",
			code: "BS"
		}, {
			name: "Bahrain",
			dial_code: "+973",
			code: "BH"
		}, {
			name: "Bangladesh",
			dial_code: "+880",
			code: "BD"
		}, {
			name: "Barbados",
			dial_code: "+1 246",
			code: "BB"
		}, {
			name: "Belgio",
			dial_code: "+32",
			code: "BE"
		}, {
			name: "Belize",
			dial_code: "+501",
			code: "BZ"
		}, {
			name: "Benin",
			dial_code: "+229",
			code: "BJ"
		}, {
			name: "Bhutan",
			dial_code: "+975",
			code: "BT"
		}, {
			name: "Bielorussia",
			dial_code: "+375",
			code: "BY"
		}, {
			name: "Bolivia",
			dial_code: "+591",
			code: "BO"
		}, {
			name: "Bosnia ed Erzegovina",
			dial_code: "+387",
			code: "BA"
		}, {
			name: "Botswana",
			dial_code: "+267",
			code: "BW"
		}, {
			name: "Brasile",
			dial_code: "+55",
			code: "BR"
		}, {
			name: "Brunei",
			dial_code: "+673",
			code: "BN"
		}, {
			name: "Bulgaria",
			dial_code: "+359",
			code: "BG"
		}, {
			name: "Burkina Faso",
			dial_code: "+226",
			code: "BF"
		}, {
			name: "Burundi",
			dial_code: "+257",
			code: "BI"
		},


		{
			name: "Cambogia",
			dial_code: "+855",
			code: "KH"
		}, {
			name: "Camerun",
			dial_code: "+237",
			code: "CM"
		}, {
			name: "Canada",
			dial_code: "+1",
			code: "CA"
		}, {
			name: "Capo Verde",
			dial_code: "+238",
			code: "CV"
		}, {
			name: "Ciad",
			dial_code: "+235",
			code: "TD"
		}, {
			name: "Cile",
			dial_code: "+56",
			code: "CL"
		}, {
			name: "Cina",
			dial_code: "+86",
			code: "CN"
		}, {
			name: "Cipro",
			dial_code: "+537",
			code: "CY"
		}, {
			name: "Colombia",
			dial_code: "+57",
			code: "CO"
		}, {
			name: "Comore",
			dial_code: "+269",
			code: "KM"
		}, {
			name: "Congo, Repubblica del",
			dial_code: "+242",
			code: "CG"
		}, {
			name: "Congo, Repubblica Democratica del",
			dial_code: "+243",
			code: "CD"
		}, {
			name: "Corea, Repubblica Democratica Popolare del",
			dial_code: "+850",
			code: "KP"
		}, {
			name: "Corea, Repubblica del",
			dial_code: "+82",
			code: "KR"
		}, {
			name: "Costa d'Avorio",
			dial_code: "+225",
			code: "CI"
		}, {
			name: "Costa Rica",
			dial_code: "+506",
			code: "CR"
		}, {
			name: "Croazia",
			dial_code: "+385",
			code: "HR"
		}, {
			name: "Cuba",
			dial_code: "+53",
			code: "CU"
		},


		{
			name: "Danimarca",
			dial_code: "+45",
			code: "DK"
		},  {
			name: "Dominica",
			dial_code: "+1 767",
			code: "DM"
		},


		{
			name: "Ecuador",
			dial_code: "+593",
			code: "EC"
		}, {
			name: "Egitto",
			dial_code: "+20",
			code: "EG"
		}, {
			name: "El Salvador",
			dial_code: "+503",
			code: "SV"
		}, {
			name: "Emirati Arabi Uniti",
			dial_code: "+971",
			code: "AE"
		}, {
			name: "Eritrea",
			dial_code: "+291",
			code: "ER"
		}, {
			name: "Estonia",
			dial_code: "+372",
			code: "EE"
		}, {
			name: "Etiopia",
			dial_code: "+251",
			code: "ET"
		},


		{
			name: "Fiji",
			dial_code: "+679",
			code: "FJ"
		}, {
			name: "Filippine",
			dial_code: "+63",
			code: "PH"
		}, {
			name: "Finlandia",
			dial_code: "+358",
			code: "FI"
		}, {
			name: "Francia",
			dial_code: "+33",
			code: "FR"
		},


		{
			name: "Gabon",
			dial_code: "+241",
			code: "GA"
		}, {
			name: "Gambia",
			dial_code: "+220",
			code: "GM"
		}, {
			name: "Georgia",
			dial_code: "+995",
			code: "GE"
		}, {
			name: "Germania",
			dial_code: "+49",
			code: "DE"
		}, {
			name: "Ghana",
			dial_code: "+233",
			code: "GH"
		}, {
			name: "Giamaica",
			dial_code: "+1 876",
			code: "JM"
		}, {
			name: "Giappone",
			dial_code: "+81",
			code: "JP"
		}, {
			name: "Gibuti",
			dial_code: "+253",
			code: "DJ"
		}, {
			name: "Giordania",
			dial_code: "+962",
			code: "JO"
		}, {
			name: "Grecia",
			dial_code: "+30",
			code: "GR"
		}, {
			name: "Grenada",
			dial_code: "+1 473",
			code: "GD"
		}, {
			name: "Guatemala",
			dial_code: "+502",
			code: "GT"
		}, {
			name: "Guinea",
			dial_code: "+224",
			code: "GN"
		}, {
			name: "Guinea-Bissau",
			dial_code: "+245",
			code: "GW"
		}, {
			name: "Guinea Equatoriale",
			dial_code: "+240",
			code: "GQ"
		}, {
			name: "Guyana",
			dial_code: "+595",
			code: "GY"
		},


		{
			name: "Haiti",
			dial_code: "+509",
			code: "HT"
		}, {
			name: "Honduras",
			dial_code: "+504",
			code: "HN"
		},


		{
			name: "India",
			dial_code: "+91",
			code: "IN"
		}, {
			name: "Indonesia",
			dial_code: "+62",
			code: "ID"
		}, {
			name: "Iran",
			dial_code: "+98",
			code: "IR"
		}, {
			name: "Iraq",
			dial_code: "+964",
			code: "IQ"
		}, {
			name: "Irlanda",
			dial_code: "+353",
			code: "IE"
		}, {
			name: "Islanda",
			dial_code: "+354",
			code: "IS"
		}, {
			name: "Isole Marshall",
			dial_code: "+692",
			code: "MH"
		}, {
			name: "Isole Salomone",
			dial_code: "+677",
			code: "SB"
		}, {
			name: "Israele",
			dial_code: "+972",
			code: "IL"
		}, {
			name: "Italia",
			dial_code: "+39",
			code: "IT"
		},


		{
			name: "Kazakhistan",
			dial_code: "+7 7",
			code: "KZ"
		}, {
			name: "Kenya",
			dial_code: "+254",
			code: "KE"
		}, {
			name: "Kirghizistan",
			dial_code: "+996",
			code: "KG"
		}, {
			name: "Kiribati",
			dial_code: "+686",
			code: "KI"
		}, {
			name: "Kuwait",
			dial_code: "+965",
			code: "KW"
		},

		{
			name: "Laos, Repubblica Popolare del",
			dial_code: "+856",
			code: "LA"
		}, {
			name: "Lesotho",
			dial_code: "+266",
			code: "LS"
		}, {
			name: "Lettonia",
			dial_code: "+371",
			code: "LV"
		}, {
			name: "Libano",
			dial_code: "+961",
			code: "LB"
		},  {
			name: "Liberia",
			dial_code: "+231",
			code: "LR"
		}, {
			name: "Libia",
			dial_code: "+218",
			code: "LY"
		}, {
			name: "Liechtenstein",
			dial_code: "+423",
			code: "LI"
		}, {
			name: "Lituania",
			dial_code: "+370",
			code: "LT"
		}, {
			name: "Lussemburgo",
			dial_code: "+352",
			code: "LU"
		},


		{
			name: "Macedonia",
			dial_code: "+389",
			code: "MK"
		}, {
			name: "Madagascar",
			dial_code: "+261",
			code: "MG"
		}, {
			name: "Malawi",
			dial_code: "+265",
			code: "MW"
		}, {
			name: "Maldive",
			dial_code: "+960",
			code: "MV"
		}, {
			name: "Malesia",
			dial_code: "+60",
			code: "MY"
		},  {
			name: "Mali",
			dial_code: "+223",
			code: "ML"
		}, {
			name: "Malta",
			dial_code: "+356",
			code: "MT"
		}, {
			name: "Marocco",
			dial_code: "+212",
			code: "MA"
		}, {
			name: "Mauritania",
			dial_code: "+222",
			code: "MR"
		}, {
			name: "Mauritius",
			dial_code: "+230",
			code: "MU"
		}, {
			name: "Messico",
			dial_code: "+52",
			code: "MX"
		}, {
			name: "Micronesia",
			dial_code: "+691",
			code: "FM"
		}, {
			name: "Moldavia",
			dial_code: "+373",
			code: "MD"
		}, {
			name: "Monaco",
			dial_code: "+377",
			code: "MC"
		}, {
			name: "Mongolia",
			dial_code: "+976",
			code: "MN"
		}, {
			name: "Montenegro",
			dial_code: "+382",
			code: "ME"
		}, {
			name: "Mozambico",
			dial_code: "+258",
			code: "MZ"
		}, {
			name: "Birmania (Myanmar)",
			dial_code: "+95",
			code: "MM"
		},


		{
			name: "Namibia",
			dial_code: "+264",
			code: "NA"
		}, {
			name: "Nauru",
			dial_code: "+674",
			code: "NR"
		}, {
			name: "Nepal",
			dial_code: "+977",
			code: "NP"
		}, {
			name: "Nicaragua",
			dial_code: "+505",
			code: "NI"
		}, {
			name: "Niger",
			dial_code: "+227",
			code: "NE"
		}, {
			name: "Nigeria",
			dial_code: "+234",
			code: "NG"
		}, {
			name: "Norvegia",
			dial_code: "+47",
			code: "NO"
		}, {
			name: "Nuova Zelanda",
			dial_code: "+64",
			code: "NZ"
		},


		{
			name: "Oman",
			dial_code: "+968",
			code: "OM"
		},


		{
			name: "Paesi Bassi",
			dial_code: "+31",
			code: "NL"
		},  {
			name: "Pakistan",
			dial_code: "+92",
			code: "PK"
		}, {
			name: "Palau",
			dial_code: "+680",
			code: "PW"
		}, {
			name: "Palestina",
			dial_code: "+970",
			code: "PS"
		}, {
			name: "Panama",
			dial_code: "+507",
			code: "PA"
		}, {
			name: "Papua Nuova Guinea",
			dial_code: "+675",
			code: "PG"
		}, {
			name: "Paraguay",
			dial_code: "+595",
			code: "PY"
		}, {
			name: "Perù",
			dial_code: "+51",
			code: "PE"
		}, {
			name: "Polonia",
			dial_code: "+48",
			code: "PL"
		}, {
			name: "Portogallo",
			dial_code: "+351",
			code: "PT"
		},


		{
			name: "Qatar",
			dial_code: "+974",
			code: "QA"
		},


		{
			name: "Regno Unito",
			dial_code: "+44",
			code: "GB"
		}, {
			name: "Repubblica Ceca",
			dial_code: "+420",
			code: "CZ"
		}, {
			name: "Repubblica Centrafricana",
			dial_code: "+236",
			code: "CF"
		}, {
			name: "Repubblica Dominicana",
			dial_code: "+1 849",
			code: "DO"
		},  {
			name: "Repubblica Sudafricana",
			dial_code: "+27",
			code: "ZA"
		}, {
			name: "Romania",
			dial_code: "+40",
			code: "RO"
		}, {
			name: "Ruanda",
			dial_code: "+250",
			code: "RW"
		}, {
			name: "Russia",
			dial_code: "+7",
			code: "RU"
		},


		{
			name: "Saint Kitts e Nevis",
			dial_code: "+1 869",
			code: "KN"
		}, {
			name: "Saint Vincent e Grenadine",
			dial_code: "+1 784",
			code: "VC"
		}, {
			name: "Samoa",
			dial_code: "+685",
			code: "WS"
		}, {
			name: "San Marino",
			dial_code: "+378",
			code: "SM"
		}, {
			name: "Santa Lucia",
			dial_code: "+1 758",
			code: "LC"
		}, {
			name: "Sao Tome e Principe",
			dial_code: "+239",
			code: "ST"
		}, {
			name: "Senegal",
			dial_code: "+221",
			code: "SN"
		}, {
			name: "Serbia",
			dial_code: "+381",
			code: "RS"
		}, {
			name: "Seychelles",
			dial_code: "+248",
			code: "SC"
		}, {
			name: "Sierra Leone",
			dial_code: "+232",
			code: "SL"
		}, {
			name: "Singapore",
			dial_code: "+65",
			code: "SG"
		}, {
			name: "Siria",
			dial_code: "+963",
			code: "SY"
		}, {
			name: "Slovacchia",
			dial_code: "+421",
			code: "SK"
		}, {
			name: "Slovenia",
			dial_code: "+386",
			code: "SI"
		},  {
			name: "Somalia",
			dial_code: "+252",
			code: "SO"
		},  {
			name: "Spagna",
			dial_code: "+34",
			code: "ES"
		}, {
			name: "Sri Lanka",
			dial_code: "+94",
			code: "LK"
		}, {
			name: "Stati Uniti",
			dial_code: "+1",
			code: "US"
		}, {
			name: "Sudan",
			dial_code: "+249",
			code: "SD"
		}, {
			name: "Suriname",
			dial_code: "+597",
			code: "SR"
		}, {
			name: "Svezia",
			dial_code: "+46",
			code: "SE"
		}, {
			name: "Svizzera",
			dial_code: "+41",
			code: "CH"
		}, {
			name: "Swaziland",
			dial_code: "+268",
			code: "SZ"
		},


		{
			name: "Tagikistan",
			dial_code: "+992",
			code: "TJ"
		}, {
			name: "Taiwan",
			dial_code: "+886",
			code: "TW"
		}, {
			name: "Tanzania",
			dial_code: "+255",
			code: "TZ"
		}, {
			name: "Thailandia",
			dial_code: "+66",
			code: "TH"
		}, {
			name: "Timor Est",
			dial_code: "+670",
			code: "TL"
		}, {
			name: "Togo",
			dial_code: "+228",
			code: "TG"
		}, {
			name: "Tonga",
			dial_code: "+676",
			code: "TO"
		}, {
			name: "Trinidad e Tobago",
			dial_code: "+1 868",
			code: "TT"
		}, {
			name: "Tunisia",
			dial_code: "+216",
			code: "TN"
		}, {
			name: "Turchia",
			dial_code: "+90",
			code: "TR"
		}, {
			name: "Turkmenistan",
			dial_code: "+993",
			code: "TM"
		}, {
			name: "Tuvalu",
			dial_code: "+688",
			code: "TV"
		},


		{
			name: "Ucraina",
			dial_code: "+380",
			code: "UA"
		}, {
			name: "Uganda",
			dial_code: "+256",
			code: "UG"
		},  {
			name: "Ungheria",
			dial_code: "+36",
			code: "HU"
		},   {
			name: "Uruguay",
			dial_code: "+598",
			code: "UY"
		}, {
			name: "Uzbekistan",
			dial_code: "+998",
			code: "UZ"
		},


		{
			name: "Vanuatu",
			dial_code: "+678",
			code: "VU"
		}, {
			name: "Città del Vaticano",
			dial_code: "+379",
			code: "VA"
		}, {
			name: "Venezuela",
			dial_code: "+58",
			code: "VE"
		}, {
			name: "Vietnam",
			dial_code: "+84",
			code: "VN"
		},


		{
			name: "Yemen",
			dial_code: "+967",
			code: "YE"
		},


		{
			name: "Zambia",
			dial_code: "+260",
			code: "ZM"
		}, {
			name: "Zimbabwe",
			dial_code: "+263",
			code: "ZW"
		}

	];

})

.factory('getCountryByCode', function(getCountries) {
	var functions = {};
	functions.get = function(code) {
		var countries = getCountries;
		for (var i = 0; i < countries.length; i++) {
			if (countries[i].code == code) {
				return countries[i];
			}
		}
	};
	return functions;
})

.filter('ucfirst', function() {
	return function(input) {
		return (!!input) ? input.charAt(0).toUpperCase() + input.substr(1).toLowerCase() : '';
	}
})

.factory('UtilityService', function ($http, getBaseApiURL, Session) {

	var utilityService = {};

	utilityService.listNets = function () {
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/utility/list-nets',
			data: {
				token: Session.token
			}
		}).then(function(result) {
			var data = result.data;

			if (data.result == 'ko') {
				return { error: data.error };
			} else if (data.result == 'ok') {
				return data.nets;
			}

		}, function (data) {
			return { status: data.status, error: data.data.error };
		});
	};

	utilityService.listRoles = function () {
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/utility/list-roles',
			data: {
				token: Session.token
			}
		}).then(function(result) {
			var data = result.data;

			if (data.result == 'ko') {
				return { error: data.error };
			} else if (data.result == 'ok') {
				return data.roles;
			}

		}, function (data) {
			return { status: data.status, error: data.data.error };
		});
	};

	utilityService.listSubRoles = function () {
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/utility/list-sub-roles',
			data: {
				token: Session.token
			}
		}).then(function(result) {
			var data = result.data;

			if (data.result == 'ko') {
				return { error: data.error };
			} else if (data.result == 'ok') {
				return data.sub_roles;
			}

		}, function (data) {
			return { status: data.status, error: data.data.error };
		});
	};

	utilityService.listStructures = function () {
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/utility/list-structures',
			data: {
				token: Session.token
			}
		}).then(function(result) {
			var data = result.data;

			if (data.result == 'ko') {
				return { error: data.error };
			} else if (data.result == 'ok') {
				return data.structures;
			}

		}, function (data) {
			return { status: data.status, error: data.data.error };
		});
	};

	utilityService.listZones = function () {
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/utility/list-zones',
			data: {
				token: Session.token
			}
		}).then(function(result) {
			var data = result.data;

			if (data.result == 'ko') {
				return { error: data.error };
			} else if (data.result == 'ok') {
				return data.zones;
			}

		}, function (data) {
			return { status: data.status, error: data.data.error };
		});
	};

	utilityService.listProvince = function () {
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/utility/list-province',
			data: {
				token: Session.token
			}
		}).then(function(result) {
			var data = result.data;

			if (data.result == 'ko') {
				return { error: data.error };
			} else if (data.result == 'ok') {
				return data.province;
			}

		}, function (data) {
			return { status: data.status, error: data.data.error };
		});
	};

	return utilityService;
});
;